/* VINYLPAC theme: artwork goes up to Shopify Files the moment a design is added to the cart (Josh 10/18), so
   "Continue to payment" only has to make the draft (checkout/README.md, "Artwork uploaded when it is added to the cart").

   On when the theme setting vp_art_early is "on" (window.VP_ART_EARLY, build_theme.py) or this browser was opened
   with ?vpart=on (vp-shim.js keeps it in localStorage vp_art_early; ?vpart=off forces it off; ?vpart=clear forgets
   it). Off: nothing here runs, and the checkout uploads at "Continue to payment" exactly as before.

   Best effort throughout: a design whose upload is missing, still running, failed, used by an earlier draft of this
   tab, or no longer matching its saved file is uploaded at checkout as before (cart-checkout.js checkoutSim). Nothing
   visible changes, and nothing here can refuse or delay a checkout beyond a short wait for an upload already running.

   Hooks (theme build only; Sue's source is untouched): cart-checkout.js addToCart() and product-order-store.js
   commit()/commitBuilderItems() call added(itemId, record, configuration) once a line is saved; bulk-order.js calls
   bulkFile(file) when a file lands on the Bulk Order Form (long before Check out), and bulk-order-cart.js waits
   settleAll() before it leaves for the cart. The patched checkoutSim asks ready()/settle()/token(), marks refs used
   by its draft (markUsed) and forgets refs the server called stale (forget), then uploads those as before.

   Storage: sessionStorage vp_art_uploads = { v:1, refs:{ 'item:<cart item id>:<part>' | 'bulk:<id>' : ref } } with
   ref = { id, url, name, mimeType, size, rawSize, rawType, original, at, usedBy? }, and vp_art_token = the per-tab
   cart token whose hash is in each file's alt text (the Worker lets only this tab put the file on a draft). */
(function () {
  'use strict';
  if (window.VPArtUpload) return;
  var STORE = 'vp_art_uploads', TOKEN_STORE = 'vp_art_token', OVERRIDE = 'vp_art_early';
  var MAX_FILE = 20 * 1024 * 1024;              // checkout Worker LIMITS.fileBytes
  var BATCH_FILES = 12, BATCH_BYTES = 40 * 1024 * 1024, PARALLEL = 3, GATHER_MS = 40;   // batches go up one after another
  var BULK_KEEP_MS = 36e5 * 24;                  // a Bulk Order Form file nobody committed: forgotten after a day (the Worker's janitor clears the file)
  var PLACEHOLDERS = { 'Artwork loaded': 1, 'Lid artwork': 1 };   // checkout app.js NAME_PLACEHOLDERS: no real name, upload at checkout
  // record field (full), record field (original), configuration file-name key, upload-name suffix
  var PARTS = { body: ['artworkUrl', 'artworkOriginalUrl', 'bodyFilename', ''], lid: ['lidArtworkUrl', 'lidArtworkOriginalUrl', 'lidFilename', '_Lid'],
    ring: ['ringArtworkUrl', 'ringArtworkOriginalUrl', 'ringFilename', '_Ring'] };
  var KNOWN_EXT = { 'application/pdf': 'pdf', 'image/png': 'png', 'image/jpeg': 'jpg', 'image/svg+xml': 'svg', 'image/webp': 'webp', 'image/gif': 'gif' };
  var OTHER_EXT = { 'image/vnd.adobe.photoshop': 'psd', 'application/postscript': 'ai', 'image/tiff': 'tif', 'image/heic': 'heic', 'application/zip': 'zip' };
  var BULK_MIME = { pdf: 'application/pdf', png: 'image/png', jpeg: 'image/jpeg', webp: 'image/webp', svg: 'image/svg+xml' };

  function warn(e) { if (window.console && console.warn) console.warn('[vp-art]', e && e.message || e); }

  function enabled() {
    try {
      var o = localStorage.getItem(OVERRIDE);
      if (o === 'on' || o === 'off') return o === 'on';
    } catch (e) {}
    return window.VP_ART_EARLY === 'on';
  }
  function api(path) {
    var base = String(window.VP_API_BASE || '').replace(/\/+$/, '');
    if (!/^https:\/\/[^/]+$|^http:\/\/(127\.0\.0\.1|localhost)(:\d+)?$/.test(base)) return '';
    return base + path;
  }
  function token() {
    var t = '';
    try { t = sessionStorage.getItem(TOKEN_STORE) || ''; } catch (e) { return ''; }
    if (/^[a-f0-9]{32}$/.test(t)) return t;
    if (!(window.crypto && window.crypto.getRandomValues)) return '';
    var b = new Uint8Array(16);
    window.crypto.getRandomValues(b);
    t = Array.prototype.map.call(b, function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
    try { sessionStorage.setItem(TOKEN_STORE, t); if (sessionStorage.getItem(TOKEN_STORE) !== t) return ''; } catch (e) { return ''; }
    return t;
  }
  function active() { return enabled() && !!api('') && !!(window.crypto && window.crypto.subtle) && !!token(); }

  // ── refs ──
  // Read afresh every time, never cached: a page the browser restores from its back-forward cache must see the refs the
  // pages after it saved (Sol 10/18 r5), and the cart itself lives in sessionStorage the same way.
  function load() {
    var s = null;
    try { s = JSON.parse(sessionStorage.getItem(STORE) || 'null'); } catch (e) { s = null; }
    if (!s || s.v !== 1 || !s.refs || typeof s.refs !== 'object') s = { v: 1, refs: {} };
    return s;
  }
  function save(s) { try { sessionStorage.setItem(STORE, JSON.stringify(s)); } catch (e) {} }
  function cartIds() {
    try { return (JSON.parse(sessionStorage.getItem('vp_cart') || '[]') || []).map(function (it) { return String(it && it.id); }); } catch (e) { return null; }
  }
  // Refs of lines no longer in the cart, and day-old Bulk Order Form files, are forgotten (the Worker's daily cleanup
  // deletes the files themselves once nothing claims them).
  function prune() {
    var ids = cartIds(), s = load(), changed = false, now = Date.now();
    Object.keys(s.refs).forEach(function (k) {
      var r = s.refs[k], m = /^item:(\d+):/.exec(k);
      if ((m && ids && ids.indexOf(m[1]) === -1) || (/^bulk:/.test(k) && (!r || now - Number(r.at) > BULK_KEEP_MS))) { delete s.refs[k]; changed = true; }
    });
    if (changed) save(s);
    // Uploads not yet sent for lines that left the cart are dropped too (Sol 10/18 r5: they must never hold up a tap).
    if (ids) cancelQueued(function (key) { var m = /^item:(\d+):/.exec(key); return !!m && ids.indexOf(m[1]) === -1; });
  }
  function orderRef() {
    var r = '';
    try { r = sessionStorage.getItem('vp_order_ref') || ''; } catch (e) {}
    return /^ORD-\d{4}-[0-9a-f]{4}$/.test(r) ? r : 'ORD-0000';
  }

  // ── files ──
  function toBlob(dataUrl) {   // cart-checkout.js dataUrlToBlob, never throwing
    var m = /^data:([^;,]+);base64,([a-z0-9+/\s]*={0,2})$/i.exec(dataUrl || '');
    if (!m || !/^[a-z0-9][a-z0-9!#$&^_.+-]*\/[a-z0-9][a-z0-9!#$&^_.+-]*$/i.test(m[1])) return null;
    var bin;
    try { bin = atob(m[2]); } catch (e) { return null; }
    if (!bin.length) return null;
    var arr = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
    return new Blob([arr], { type: m[1] });
  }
  function extFor(type, original) {   // cart-checkout.js cartUploadExt(), with the customer's own name
    if (KNOWN_EXT[type]) return KNOWN_EXT[type];
    var m = /\.([a-z0-9]{1,10})$/i.exec(String(original || '').trim());
    if (m) return m[1].toLowerCase();
    return OTHER_EXT[type] || 'bin';
  }
  function bulkKind(file) {   // bulk-order-cart.js kindOf()
    var name = String(file && file.name || '').toLowerCase(), type = String(file && file.type || '').toLowerCase();
    if (type === 'application/pdf' || /\.pdf$/.test(name)) return 'pdf';
    if (type === 'image/png' || /\.png$/.test(name)) return 'png';
    if (type === 'image/jpeg' || /\.jpe?g$/.test(name)) return 'jpeg';
    if (type === 'image/webp' || /\.webp$/.test(name)) return 'webp';
    if (type === 'image/svg+xml' || /\.svg$/.test(name)) return 'svg';
    return 'file';
  }
  // The type the form's cart line will carry (bulk-order-cart.js mimeOf + rowArtwork): the bytes are the file's own.
  function bulkMime(file) {
    var k = bulkKind(file);
    if (BULK_MIME[k]) return BULK_MIME[k];
    var a = window.VPArtFiles;
    return (a && typeof a.mime === 'function' ? a.mime(file) : '') || String(file.type || '') || 'application/octet-stream';
  }
  // SHA-256 of a blob's bytes (hex). A Bulk Order Form file is matched to the line it becomes by name, size, type AND
  // these bytes (Sol 10/18: a same-size revision of a file must never pick up the old upload).
  function sha256(blob) {
    return blob.arrayBuffer().then(function (buf) { return window.crypto.subtle.digest('SHA-256', buf); })
      .then(function (d) { return Array.prototype.map.call(new Uint8Array(d), function (x) { return ('0' + x.toString(16)).slice(-2); }).join(''); });
  }

  // Shopify's file CDN re-encodes or refuses picture bytes it can read (TIFF, PSD, HEIC, a PNG over Shopify's image
  // limits...), so Command could not download the customer's original (overnight test 10/17, orders #4141-#4143). Those
  // files are stored as "<name>.<ext>.bin" with the 16-byte VINYLPAC-RAWPNG tag in front: the CDN then serves them byte
  // for byte, and Command strips the tag. PNG/JPG/WebP within Shopify's image limits stay MediaImages (their
  // originalSource is the exact upload). SAME TEXT as checkout/patch_cart_checkout.py (test_handoff.mjs checks).
  var VP_RAW_TAG = 'VINYLPAC-RAWPNG\n';
  var VP_PICTURE_EXT = /^(png|jpe?g|webp|gif|tiff?|psd|psb|heic|heif|bmp|avif|jp2|jpx|ico|dng|cr2|nef|arw)$/i;
  function vpPixels(buf) {
    var d = new DataView(buf), n = buf.byteLength;
    if (n > 24 && d.getUint32(0) === 0x89504e47) return { w: d.getUint32(16), h: d.getUint32(20) };
    if (n > 30 && d.getUint32(0) === 0x52494646 && d.getUint32(8) === 0x57454250) {
      var c = d.getUint32(12);
      if (c === 0x56503858) return { w: 1 + (d.getUint8(24) | d.getUint8(25) << 8 | d.getUint8(26) << 16), h: 1 + (d.getUint8(27) | d.getUint8(28) << 8 | d.getUint8(29) << 16) };
      if (c === 0x5650384c) { var bits = d.getUint32(21, true); return { w: 1 + (bits & 0x3fff), h: 1 + ((bits >>> 14) & 0x3fff) }; }
      if (c === 0x56503820) return { w: d.getUint16(26, true) & 0x3fff, h: d.getUint16(28, true) & 0x3fff };
      return null;
    }
    if (n > 4 && d.getUint16(0) === 0xffd8) {
      var i = 2;
      while (i + 9 < n) {
        if (d.getUint8(i) !== 0xff) { i++; continue; }
        var m = d.getUint8(i + 1);
        if (m === 0xff) { i++; continue; }
        if (m >= 0xc0 && m <= 0xcf && m !== 0xc4 && m !== 0xc8 && m !== 0xcc) return { w: d.getUint16(i + 7), h: d.getUint16(i + 5) };
        if (m === 0x01 || (m >= 0xd0 && m <= 0xd8)) { i += 2; continue; }
        i += 2 + d.getUint16(i + 2);
      }
    }
    return null;
  }
  function vpNeedsRawTag(file, head) {
    var ext = String(file.name || '').split('.').pop();
    var type = String(file.mimeType || '').toLowerCase();
    if (!((/^image\//.test(type) && !/svg/.test(type)) || VP_PICTURE_EXT.test(ext))) return false;
    if (!/^image\/(png|jpeg|webp)$/.test(type)) return true;
    var px = head ? vpPixels(head) : null;
    return !px || px.w * px.h > 20000000 || px.w > 20 * px.h || px.h > 20 * px.w;   // unknown size: tag it (Astra 10/17)
  }
  function vpRawWrapFiles(files) {
    return Promise.all(files.map(function(file) {
      var head = file.blob && typeof file.blob.slice === 'function' && typeof file.blob.slice(0, 1).arrayBuffer === 'function'
        ? file.blob.slice(0, 262144).arrayBuffer().catch(function() { return null; }) : Promise.resolve(null);
      return head.then(function(buf) {
        if (!vpNeedsRawTag(file, buf)) return file;
        var blob = new Blob([VP_RAW_TAG, file.blob], { type: 'application/octet-stream' });
        return Object.assign({}, file, { name: file.name + '.bin', mimeType: 'application/octet-stream', size: blob.size, blob: blob });
      });
    }));
  }

  // ── the Worker ──
  function request(path, body, timeoutMs) {
    return new Promise(function (resolve, reject) {
      var url = api(path);
      if (!url) { reject(new Error('checkout not connected')); return; }
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); reject(new Error(path + ' timed out')); }, timeoutMs);
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(body), signal: controller.signal, credentials: 'omit' })
        .then(function (r) { return r.json().catch(function () { return null; }).then(function (data) {
          if (!r.ok || !data || data.ok === false) throw new Error(path + ' HTTP ' + r.status + (data && data.message ? ': ' + data.message : ''));
          return data;
        }); })
        .then(function (data) { clearTimeout(timer); resolve(data); }, function (e) { clearTimeout(timer); reject(e); });
    });
  }
  function stagedUrl(target) {
    var url = new URL(target && target.url);
    if (url.protocol !== 'https:' || url.hostname !== 'shopify-staged-uploads.storage.googleapis.com' ||
        url.username || url.password || url.port || !target.resourceUrl || !Array.isArray(target.parameters)) {
      throw new Error('The artwork upload address is invalid.');
    }
    return url.href;
  }
  // Josh 10/29: sent as an XHR so a tap waiting on it can say how far it is ("Uploading your artwork… 60%", bytes()).
  // An XHR that never reached the storage (no XHR, or a browser refusing its CORS check) goes again as before: one
  // more POST of the same form to the same staged target is harmless.
  function postStaged(file) {
    var form = new FormData();
    file.target.parameters.forEach(function (p) { form.append(p.name, p.value); });
    form.append('file', file.blob, file.target.name || file.name);
    var p = progress[file.entry.key];
    if (typeof XMLHttpRequest !== 'function') return postStagedFetch(file, form);
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest(), fallBack = false;
      x.open('POST', stagedUrl(file.target));
      x.timeout = 300000;
      if (p && x.upload) x.upload.onprogress = function (e) { if (e.lengthComputable && e.total > 0) p.sent = Math.min(p.total, Math.round(p.total * e.loaded / e.total)); };
      x.onload = function () { if (x.status >= 200 && x.status < 300) { if (p) p.sent = p.total; resolve(); } else reject(new Error('staged upload HTTP ' + x.status)); };
      x.onerror = function () { fallBack = true; resolve(postStagedFetch(file, form)); };
      x.ontimeout = function () { reject(new Error('staged upload timed out')); };
      try { x.send(form); } catch (e) { if (!fallBack) resolve(postStagedFetch(file, form)); }
    });
  }
  function postStagedFetch(file, form) {
    var p = progress[file.entry.key];
    if (p) p.sent = 0;
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 300000);
    return fetch(stagedUrl(file.target), { method: 'POST', body: form, signal: controller.signal, credentials: 'omit' }).then(function (r) {
      clearTimeout(timer);
      if (!r.ok) throw new Error('staged upload HTTP ' + r.status);
      if (p) p.sent = p.total;
    }, function (e) { clearTimeout(timer); throw e; });
  }
  function parallel(list, n, fn) {
    var i = 0;
    function next() { if (i >= list.length) return Promise.resolve(); var x = list[i++]; return fn(x).then(next); }
    var lanes = [];
    for (var k = 0; k < Math.min(n, list.length); k++) lanes.push(next());
    return Promise.all(lanes);
  }

  // ── the queue: files added within a moment go up as one batch (one /uploads, one /art) ──
  var queue = [], timer = null, inflight = {}, pendingFp = {};
  var progress = {}, alias = {};   // entry key -> { sent, total } bytes on their way up; a Bulk Order line -> the file it took
  var pending = [], sending = null;   // batches waiting their turn, and the one going up now
  function enqueue(entry) {   // { key, blob, original, part, ref } -> Promise<ref|null>
    var p = new Promise(function (resolve) { entry.done = resolve; });
    entry.promise = p;
    inflight[entry.key] = p;
    var mine = progress[entry.key] = { sent: 0, total: entry.blob.size };
    p.then(function () { if (inflight[entry.key] === p) delete inflight[entry.key]; delete pendingFp[entry.key]; if (progress[entry.key] === mine) delete progress[entry.key]; });
    queue.push(entry);
    clearTimeout(timer);
    timer = setTimeout(flush, GATHER_MS);
    return p;
  }
  // One batch at a time: the first files are usable while the rest still go up. Batches wait in `pending`, where an
  // entry can still be taken out (cancelQueued: a line that left the cart, or one the tap would rather upload itself
  // than wait behind other work).
  function flush() {
    timer = null;
    while (queue.length) {
      var batch = [], bytes = 0;
      while (queue.length && batch.length < BATCH_FILES && (!batch.length || bytes + queue[0].blob.size <= BATCH_BYTES)) { bytes += queue[0].blob.size; batch.push(queue.shift()); }
      pending.push(batch);
    }
    pump();
  }
  function pump() {
    if (sending || !pending.length) return;
    var batch = pending.shift();
    if (!batch.length) { pump(); return; }
    sending = batch;
    sendBatch(batch).then(function () { sending = null; pump(); }, function () { sending = null; pump(); });
  }
  // Take entries whose key `test` accepts out of the queue and of batches not yet started; each resolves to null
  // (nothing stored), so a checkout uploads that line itself. A batch already going up is left alone.
  function cancelQueued(test) {
    var dropped = [];
    queue = queue.filter(function (e) { if (test(e.key)) { dropped.push(e); return false; } return true; });
    pending = pending.map(function (b) { return b.filter(function (e) { if (test(e.key)) { dropped.push(e); return false; } return true; }); }).filter(function (b) { return b.length; });
    dropped.forEach(function (e) {
      if (inflight[e.key] === e.promise) delete inflight[e.key];   // now, not a microtask later: inFlight() must not see it
      delete pendingFp[e.key];
      e.done(null);
    });
    return dropped.length;
  }
  function queued(key) {   // waiting, not yet going up
    return queue.some(function (e) { return e.key === key; }) || pending.some(function (b) { return b.some(function (e) { return e.key === key; }); });
  }
  function sendBatch(batch) {
    var ref = batch[0].ref || 'ORD-0000';
    var files = batch.map(function (e, i) {
      return { key: e.part + '_' + i, name: ref + PARTS[e.part][3] + '.' + extFor(e.blob.type, e.original), mimeType: e.blob.type, size: e.blob.size, blob: e.blob, entry: e };
    });
    var give = function (f, r) { f.entry.done(r); };
    return vpRawWrapFiles(files).then(function (ready) {
      return request('/api/checkout/uploads', { orderRef: ref, files: ready.map(function (f) { return { key: f.key, name: f.name, mimeType: f.mimeType, size: f.size }; }) }, 30000)
        .then(function (data) {
          var targets = data.targets || {};
          ready.forEach(function (f) { f.target = targets[f.key]; if (!f.target || !f.target.resourceUrl) throw new Error('upload target missing'); stagedUrl(f.target); });
          return parallel(ready, PARALLEL, postStaged);
        })
        .then(function () {
          return request('/api/checkout/art', { token: token(), orderRef: ref, files: ready.map(function (f) {
            return { key: f.key, resourceUrl: f.target.resourceUrl, name: f.target.name || f.name, mimeType: f.mimeType, size: f.size, original: f.entry.original };
          }) }, 120000);
        })
        .then(function (data) {
          var made = data.files || {}, s = load();   // fresh: other events may have saved meanwhile
          ready.forEach(function (f) {
            var r = made[f.key];
            if (!r || !r.id) { give(f, null); return; }
            var out = { id: String(r.id), url: String(r.url || ''), name: String(r.name || f.name), mimeType: f.mimeType, size: f.size,
              rawSize: f.entry.blob.size, rawType: f.entry.blob.type, original: f.entry.original, at: Date.now() };
            if (f.entry.sha) out.sha = f.entry.sha;   // Bulk Order Form files: matched to their line by bytes too
            s.refs[f.entry.key] = out;
            give(f, out);
          });
          save(s);
        });
    }).catch(function (e) {
      warn(e);   // the checkout uploads these as before
      files.forEach(function (f) { give(f, null); });
    });
  }

  // A Bulk Order Form file already on its way up (bulkFile) becomes this cart line's, once: same name, size, type and bytes.
  function adoptBulk(key, original, blob, sha) {
    var s = load(), fp = original + '|' + blob.size + '|' + blob.type + '|' + sha;
    var done = Object.keys(s.refs).filter(function (k) { var r = s.refs[k]; return /^bulk:/.test(k) && r && !r.used && r.id && r.original === original && r.rawSize === blob.size && r.rawType === blob.type && r.sha === sha; });
    if (done.length) {
      var r = s.refs[done[0]];
      r.used = true;
      s.refs[key] = { id: r.id, url: r.url, name: r.name, mimeType: r.mimeType, size: r.size, rawSize: r.rawSize, rawType: r.rawType, original: r.original, at: r.at };
      save(s);
      return true;
    }
    var running = Object.keys(pendingFp).filter(function (k) { return pendingFp[k] === fp && inflight[k]; });
    if (!running.length) return false;
    var bk = running[0];
    delete pendingFp[bk];   // this line takes it; a second identical row uploads its own
    inflight[key] = inflight[bk].then(function (r) {
      if (!r) return null;
      var st = load();
      if (st.refs[bk]) st.refs[bk].used = true;
      st.refs[key] = { id: r.id, url: r.url, name: r.name, mimeType: r.mimeType, size: r.size, rawSize: r.rawSize, rawType: r.rawType, original: r.original, at: r.at };
      save(st);
      return st.refs[key];
    });
    alias[key] = bk;
    inflight[key].then(function () { delete inflight[key]; if (alias[key] === bk) delete alias[key]; });
    return true;
  }

  // ── public ──
  // A cart line was saved (cart-checkout.js addToCart, product-order-store.js commit / commitBuilderItems).
  function added(itemId, record, configuration) {
    try {
      if (!active() || !record || typeof record !== 'object') return;
      prune();
      var c = configuration && typeof configuration === 'object' ? configuration : {};
      Object.keys(PARTS).forEach(function (part) {
        var P = PARTS[part], data = record[P[1]] || record[P[0]];
        if (!data || typeof data !== 'string') return;
        var original = String(c[P[2]] || '').trim();
        if (!original || PLACEHOLDERS[original]) return;   // the Worker names the file after it; without one, upload at checkout as before
        var key = 'item:' + itemId + ':' + part;
        if (load().refs[key] || inflight[key]) return;
        var blob = toBlob(data);
        if (!blob || blob.size > MAX_FILE) return;
        var hasPool = Object.keys(load().refs).some(function (k) { return /^bulk:/.test(k); }) || Object.keys(pendingFp).length > 0;
        if (!hasPool) { enqueue({ key: key, blob: blob, original: original, part: part, ref: orderRef() }); return; }
        // a Bulk Order Form line: find the form's upload of these very bytes, else upload now (the key is in flight while hashing)
        inflight[key] = sha256(blob).then(function (sha) {
          delete inflight[key];
          if (load().refs[key]) return load().refs[key];
          if (adoptBulk(key, original, blob, sha)) return inflight[key] || load().refs[key] || null;
          return enqueue({ key: key, blob: blob, original: original, part: part, ref: orderRef() });
        }, function () { delete inflight[key]; return enqueue({ key: key, blob: blob, original: original, part: part, ref: orderRef() }); });
      });
    } catch (e) { warn(e); }
  }
  // A file landed on the Bulk Order Form (bulk-order.js): up it goes while the customer fills in the rest.
  function bulkFile(file) {
    try {
      if (!active() || !file || !file.size || file.size > MAX_FILE) return;
      var name = String(file.name || '').trim();
      if (!name || PLACEHOLDERS[name]) return;
      prune();
      var type = bulkMime(file);
      var blob = type === file.type ? file : new Blob([file], { type: type });
      sha256(blob).then(function (sha) {
        var fp = name + '|' + file.size + '|' + type + '|' + sha, s = load();
        var have = Object.keys(s.refs).some(function (k) { var r = s.refs[k]; return /^bulk:/.test(k) && r && !r.used && r.original === name && r.rawSize === file.size && r.rawType === type && r.sha === sha; }) ||
          Object.keys(pendingFp).some(function (k) { return pendingFp[k] === fp; });
        if (have) return;
        var key = 'bulk:' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
        pendingFp[key] = fp;
        enqueue({ key: key, blob: blob, sha: sha, original: name, part: 'body', ref: orderRef() });
      }, warn);
    } catch (e) { warn(e); }
  }
  // The checkout: the stored file for this exact blob, unless an earlier draft of this tab took it (then upload anew).
  function ready(itemId, part, blob, key) {
    try {
      if (!active() || !blob) return null;
      var r = load().refs['item:' + itemId + ':' + part];
      if (!r || !r.id || r.rawSize !== blob.size || r.rawType !== blob.type) return null;
      if (r.usedBy && r.usedBy !== key) return null;
      return { id: r.id, url: r.url, name: r.name, mimeType: r.mimeType, size: r.size };
    } catch (e) { return null; }
  }
  function pendingOf(list) {
    return (list || []).map(function (x) { return inflight['item:' + x.itemId + ':' + x.part]; }).filter(Boolean);
  }
  // The tap: keys of these lines whose upload is going up right now. Lines only queued behind other work are taken
  // back (the checkout uploads them itself, at once, side by side with the wait for the ones going up).
  function inFlight(list) {
    var keys = (list || []).map(function (x) { return 'item:' + x.itemId + ':' + x.part; });
    cancelQueued(function (key) { return keys.indexOf(key) !== -1 && queued(key); });
    return keys.filter(function (k) { return !!inflight[k]; });
  }
  // Wait (at most ms) for these lines' uploads going up right now; queued ones are taken back first. Never rejects.
  function settle(list, ms) {
    inFlight(list);
    var p = pendingOf(list);
    if (!p.length) return Promise.resolve();
    return Promise.race([Promise.all(p), new Promise(function (resolve) { setTimeout(resolve, ms); })]).then(function () {}, function () {});
  }
  // Any of these lines' uploads still queued or going up (nothing is taken back: the cart's background checkout,
  // Josh 10/19, only waits for them).
  function busy(list) {
    return (list || []).some(function (x) { return !!inflight['item:' + x.itemId + ':' + x.part]; });
  }
  // How far these lines' uploads going up now are: [bytes sent, bytes in all] (a tap that waits on them says so).
  function bytes(list) {
    var sent = 0, total = 0;
    (list || []).forEach(function (x) {
      var key = 'item:' + x.itemId + ':' + x.part, p = inflight[key] && (progress[key] || progress[alias[key]]);
      if (p) { sent += p.sent; total += p.total; }
    });
    return [sent, total];
  }
  function settleAll(ms) {
    var p = Object.keys(inflight).map(function (k) { return inflight[k]; });
    if (!p.length) return Promise.resolve();
    return Promise.race([Promise.all(p), new Promise(function (resolve) { setTimeout(resolve, ms); })]).then(function () {}, function () {});
  }
  // These lines' files go on the draft for `key` (written before the draft request, so a lost answer still counts).
  function markUsed(list, key) {
    try {
      var s = load();
      (list || []).forEach(function (x) { var r = s.refs['item:' + x.itemId + ':' + x.part]; if (r) r.usedBy = key; });
      save(s);
    } catch (e) {}
  }
  // The server proved nothing was made for `key` (4xx): the files are free for the next attempt.
  function release(key) {
    try {
      var s = load();
      Object.keys(s.refs).forEach(function (k) { if (s.refs[k] && s.refs[k].usedBy === key) delete s.refs[k].usedBy; });
      save(s);
    } catch (e) {}
  }
  // The server called these stale (gone, changed, or another cart's draft has them): upload them again at checkout.
  function forget(list) {
    try {
      var s = load();
      (list || []).forEach(function (x) { delete s.refs['item:' + x.itemId + ':' + x.part]; });
      save(s);
    } catch (e) {}
  }
  function forgetAll() { save({ v: 1, refs: {} }); }
  if (window.addEventListener) window.addEventListener('vp-cart-paid', function () { try { forgetAll(); } catch (e) {} });

  // Uploads a page left behind (the browser went to another builder page, or the Bulk Order Form left for the cart,
  // while a design's art was still going up die with that page): on every art page's load, cart lines with no ref yet
  // are read from the cart's own artwork store (IndexedDB vinylpac_artwork, product-order-store.js) and sent up again.
  // Never while a checkout runs (it uploads what it needs itself), never for jar cases, never creating the store.
  function catchUp() {
    try {
      if (!active() || window._cartCheckingOut === true || !window.indexedDB) return;
      prune();
      var items = [];
      try { items = JSON.parse(sessionStorage.getItem('vp_cart') || '[]') || []; } catch (e) { return; }
      var s = load();
      var want = items.filter(function (it) {
        if (!it || !it.id || it.cat === 'jars' || (it.configuration && it.configuration.kind === 'jars')) return false;
        return !['body', 'lid', 'ring'].some(function (p) { return s.refs['item:' + it.id + ':' + p] || inflight['item:' + it.id + ':' + p]; });
      });
      if (!want.length) return;
      var req = window.indexedDB.open('vinylpac_artwork', 1);
      req.onupgradeneeded = function () { try { req.transaction.abort(); } catch (e) {} };   // no store yet: nothing to pick up
      req.onerror = function () {};
      req.onsuccess = function () {
        var db = req.result;
        try {
          if (!db.objectStoreNames.contains('artworks')) { db.close(); return; }
          var tx = db.transaction('artworks', 'readonly'), store = tx.objectStore('artworks');
          want.forEach(function (it) {
            var g = store.get(it.id);
            g.onsuccess = function () { if (g.result && window._cartCheckingOut !== true) added(it.id, g.result, it.configuration); };
          });
          tx.oncomplete = tx.onerror = tx.onabort = function () { try { db.close(); } catch (e) {} };
        } catch (e) { try { db.close(); } catch (x) {} }
      };
    } catch (e) { warn(e); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', catchUp); else setTimeout(catchUp, 0);
  if (window.addEventListener) window.addEventListener('pageshow', function (e) { if (e && e.persisted) catchUp(); });

  window.VPArtUpload = Object.freeze({
    enabled: enabled, active: active, token: token, added: added, bulkFile: bulkFile, ready: ready, settle: settle, settleAll: settleAll, bytes: bytes,
    markUsed: markUsed, release: release, forget: forget, forgetAll: forgetAll, wrap: vpRawWrapFiles, catchUp: catchUp, inFlight: inFlight, busy: busy,
    _refs: function () { return JSON.parse(JSON.stringify(load().refs)); },   // tests
  });
})();
